import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { catchError, Observable, of, map } from 'rxjs';

import { CompanyRequestService } from './shared/services/company-request.service';
import { CompanyParamsService } from './core/services/company-params.service';
import { SortCruiseByService } from './shared/services/sort-cruise-by.service';
import { Location } from '@angular/common';
import { FavIconRequestService } from './shared/services/favicon-request.service';
import { NgWebflowService } from 'webflow-lib';

@Injectable({
  providedIn: 'root',
})
export class AppResolver implements Resolve<any> {
  POSITION_COMPANY_NAME = 1;

  companyName = this.location.path().split('/')[this.POSITION_COMPANY_NAME];
  favIcon: any;
  constructor(
    private companyRequestService: CompanyRequestService,
    private sortCruiseByService: SortCruiseByService,
    private companyParamsService: CompanyParamsService,
    private favIconRequestService: FavIconRequestService,
    private ngWebflowService: NgWebflowService,
    private location: Location
  ) {
    if (typeof document !== 'undefined') {
      this.favIcon = document.querySelector('#appIcon');
    }
  }
  resolve(route: ActivatedRouteSnapshot): Observable<any> {

    this.favIconRequestService.setFavicons();

    return this.companyRequestService.requestServer().pipe(
      map((response) => {
        this.companyParamsService.setCompanyparams(response, this.companyName);
        // webflow-lib: el slug de la agencia (findCompany().path) viaja en el body
        // de addWebflow a la altura de ngWebflowAppName; llega antes del primer POST
        this.ngWebflowService.setCompanyPath(response?.path ?? '');
        // código de la empresa (findCompany().code) EN CRUDO, p. ej. "MTA1"; el backend
        // lo decodifica y persiste "105". Opcional: si no llega, el backend lo omite.
        this.ngWebflowService.setCompanyCode(response?.code ?? '');
        this.sortCruiseByService.fetchWithParamasofCompany(
          this.companyParamsService.getCompanyParams().listFilters
        );
      }),
      catchError((error) => {
        return of('No data');
      })
    );
  }
}
